/**
 * QuestionType
 * Enum representing question types.
 *
 * @property SINGLE - Single choice.
 * @property MULTIPLE - Multiple choice.
 * @property FILL - Fill in the blank.
 * @property VOICE - Voice answer.
 * @property MATCHING - Matching.
 * @property LONG - Long answer.
 * @property TRANSLATE - Translate.
 */
export enum QuestionType {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
  FILL = 'fill',
  VOICE = 'voice',
  MATCHING = 'matching',
  LONG = 'long',
  TRANSLATE = 'translate',
}
